import React, { useState, useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  ListGroup,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ApiTokenManageListItem from './ApiTokenManageListItem'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import GenerateDictionaryModal from './GenerateDictionaryModal'

// ApiTokenManager
const ApiTokenManager = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false);
  let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [shareableDictionarySuggestions, setShareableDictionarySuggestions] = useState([])
  let [addDictModalOpen, setAddDictModalOpen] = useState(false)
  let [copyFromApiKeyId, setCopyFromApiKeyId] = useState("")

  let [shareableTrackingKeywordSuggestions, setShareableTrackingKeywordSuggestions] = useState([])

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    if (subscription_status !== "active") {
      navigate("/api_manager_top")
      return
    }

    _getDeepSpeechTokens()
    _getSharableDictionaryList()
    _getSharableTrackingKeywordList()
  }

  // get tokens
  let _getDeepSpeechTokens = async () => {

    try {
      // logout on server
      let _results = await MyAPI.getDeepSpeechTokens({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      setDeepSpeechTokens(_results.list1)

      // console.log("setDeepSpeechTokens: ", _results.list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // _getSharableDictionaryList
  let _getSharableDictionaryList = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getSharableDictionaryList({
        login_token: login_token,
        include_public: true,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }
      // console.log("getSharableDictionaryList._results: ", _results)

      let _suggestions = []
      if (_results && _results.list1) {
        for (let i=0; i<_results.list1.length; i++) {

          let _item = _results.list1[i]

          let _exists = false
          for (let j=0; j<_suggestions.length; j++) {
            if (_suggestions[j].id === _item._id) {
              _exists = true
              break
            }
          }

          if (_exists === false) {
            _suggestions.push({
              id: _item._id,
              name: _item.dictionary_name,
            })
          }
        }
      }

      setShareableDictionarySuggestions(_suggestions)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
    setLoading(false)
  }


  // get sharable tracking keyword list
  let _getSharableTrackingKeywordList = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getSharableTrackingKeywordList({
        login_token: login_token,
        include_public: true,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }
      // console.log("getSharableTrackingKeywordList._results: ", _results)


      let _suggestions = []
      if (_results && _results.list1) {
        for (let i=0; i<_results.list1.length; i++) {

          let _item = _results.list1[i]

          let _exists = false
          for (let j=0; j<_suggestions.length; j++) {
            if (_suggestions[j].id === _item._id) {
              _exists = true
              break
            }
          }

          if (_exists === false) {
            _suggestions.push({
              id: _item._id,
              name: _item.list_name,
            })
          }
        }
      }

      setShareableTrackingKeywordSuggestions(_suggestions)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
    setLoading(false)
  }


  // toggle key status between disabled or not
  let _toggleKeyStatus = async({token_id}) => {

    // send requests
    try {
      // logout on server
      let _results = await MyAPI.toggleKeyStatus({
        login_token: login_token,
        token_id: token_id,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      _getDeepSpeechTokens()

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  let _updateMemo = async({
    token_id,
    memo,
  }) => {
    // send requests
    try {
      // logout on server
      let _results = await MyAPI.updateTokenMemo({
        login_token: login_token,
        token_id: token_id,
        memo: memo,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      _getDeepSpeechTokens()

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // re-generate api key
  let _recreateKey = async(item) => {

    // send requests
    try {
      // logout on server
      let _results = await MyAPI.recreateAPIKey({
        login_token: login_token,
        api_key_id: item._id,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // get token again
      _getDeepSpeechTokens()

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // show alert
  let _showAlert = (message, type) => {

    if (type === "info") {
      Alert.info(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "success") {
      Alert.success(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "error") {
      Alert.error(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // // show alert
  // let _showAlert = () => {
  //   Alert.info("コピーしました", {
  //     position: 'top-right',
  //     effect: 'slide',
  //     timeout: 5000
  //   });
  // }
  // // show alert
  // let _showAlert2 = (text) => {
  //   Alert.info(text, {
  //     position: 'top-right',
  //     effect: 'slide',
  //     timeout: 5000
  //   });
  // }

  // _generateNewKey
  let _generateNewKey = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.generateNewApiKey({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // get token again
      _getDeepSpeechTokens()

      Alert.success("作成しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }






  // show generate new dictionary key modal
  let _showGenerateNewDicionaryModal = (api_key_id) => {

    setCopyFromApiKeyId(api_key_id)
    setAddDictModalOpen(true)
  }

  let _closeAddDictModal = () => {
    setAddDictModalOpen(false)
  }

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'right',
            fontSize: 16,
          }}>

            <span onClick={_generateNewKey} style={{
              cursor: 'pointer',
              color: '#ffffff',
              backgroundColor: '#125375',
              paddingTop: 6,
              paddingBottom: 6,
              paddingRight: 12,
              paddingLeft: 12,
              borderRadius: 4,
            }}>
              新しいキーを生成する
            </span>

          </Col>

        </Row>



        <ListGroup>

        {login_token && deepSpeechTokens.map((item, idx) => (
          <ApiTokenManageListItem
            idx={idx}
            showGenerateNewDicionaryModal={_showGenerateNewDicionaryModal}
            shareableDictionarySuggestions={shareableDictionarySuggestions}
            shareableTrackingKeywordSuggestions={shareableTrackingKeywordSuggestions}
            login_token={login_token}
            setLoading={setLoading}
            showAlert={_showAlert}
            recreateKey={_recreateKey}
            toggleKeyStatus={_toggleKeyStatus}
            updateMemo={_updateMemo}
            key={item._id+item.disabled.toString()}
            item={item}
            />
        ))}

        </ListGroup>

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* add new dictionary modal */}
      <GenerateDictionaryModal
        copyFromApiKeyId={copyFromApiKeyId}
        copyFromApi={true}
        login_token={login_token}
        showAlert={_showAlert}
        setLoading={setLoading}
        closeModal={_closeAddDictModal}
        isOpen={addDictModalOpen} />


      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiTokenManager
